package com.mencanhealth.admin.model

import kotlinx.serialization.Serializable

enum class SubscriptionTier {
    FREE, PRO, PREMIUM, ADMIN
}

@Serializable
data class ChatMessage(
    val id: String = "",
    val sender: String = "",
    val text: String = "",
    val timestamp: Long = 0L,
    val read: Boolean = false
)

data class AdminUser(
    val uid: String,
    val email: String,
    val tier: SubscriptionTier,
    val displayName: String? = null,
    val lastSync: Long? = null
)

data class ChatSummary(
    val userId: String,
    val userName: String,
    val lastMessage: String,
    val lastTimestamp: Long,
    val unreadCount: Int = 0
)

data class AdminAuthState(
    val isAuthenticated: Boolean = false,
    val isAdmin: Boolean = false,
    val email: String? = null,
    val userId: String? = null,
    val isLoading: Boolean = false,
    val error: String? = null
)

data class DeletionRequest(
    val id: String,
    val email: String,
    val reason: String,
    val requestedAt: Long,
    val status: String,
    val completedAt: Long? = null
)

data class DashboardStats(
    val totalUsers: Int = 0,
    val freeUsers: Int = 0,
    val proUsers: Int = 0,
    val premiumUsers: Int = 0,
    val adminUsers: Int = 0
)
